import { init } from "../init";
import { EnterpriseContactSalesPage } from "../pages/enterprise/contact/enterprise-contact-sales-page";
init(EnterpriseContactSalesPage);
